import React from 'react'
import Rotas from './rotas'
import AuthenticationProvider from './authenticationProvider'
import 'bootswatch/dist/flatly/bootstrap.css'
import 'toastr/build/toastr.css'

import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'

const App = () => {
    return (
        <AuthenticationProvider>
            <Rotas />
        </AuthenticationProvider>
    );
}

export default App;